import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.RequestSearchPopup.NetSuiteSearchFields', {
    requestorFieldTitle: 'Requester',
    requestorPlaceholder: 'Select requester',
    netSuiteTransactionNumberFieldTitle: 'Transaction number',
    netSuiteTransactionNumberFieldPlaceholder: 'Enter transaction number',
    netSuiteReferenceFieldTitle: 'Reference',
    netSuiteReferenceFieldPlaceholder: 'Enter reference',
    netSuiteVendorFieldTitle: 'Vendor',
    netSuiteVendorFieldPlaceholder: 'Selector vendor',
    netSuitePayeeFieldTitle: 'Payee',
    netSuitePayeeFieldPlaceholder: 'Select a payee',
    netSuiteEmployeeFieldTitle: 'Employee',
    netSuiteEmployeeFieldPlaceholder: 'Selector employee',
    netSuiteDepartmentFieldTitle: 'Department',
    netSuiteDepartmentFieldPlaceholder: 'Select a department',
    netSuiteClassFieldTitle: 'Class',
    netSuiteClassFieldPlaceholder: 'Select a class',
    netSuiteLocationFieldTitle: 'Location',
    netSuiteLocationFieldPlaceholder: 'Select a location',
    netSuiteDateFieldTitle: 'Date',
    netSuiteDueDateFieldTitle: 'Due date',
    netSuitePOReferenceTitle: 'Transaction number',
    netSuitePOReferencePlaceholder: 'Enter transaction number',
    netSuitePOVendorReferenceTitle: 'Reference',
    netSuitePOVendorReferencePlaceholder: 'Enter reference',
    netSuiteCustomerFieldTitle: 'Customer',
    netSuiteCustomerFieldPlaceholder: 'Select customer',
    netSuiteCustomPlaceholder: 'Enter value',
    dateGreaterEqualsPlaceholder: 'Enter date',
    dateLessEqualsPlaceholder: 'Enter date',
    dateFieldTitle: 'Date',
    dateFromLabel: 'From',
    dateToLabel: 'To',
});
